import React from 'react';
import { Phone, FileText } from 'lucide-react';

const MobileCTA = () => {
  const scrollToDevis = () => {
    const element = document.getElementById('devis');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-[#E3EDF9] shadow-[0_-4px_20px_rgba(1,22,45,0.12)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-cta-bar"
    >
      <div className="grid grid-cols-2 gap-2 p-2">
        <a
          href="tel:0620604166"
          className="flex items-center justify-center gap-2 bg-[#01162D] text-white py-3 rounded-md font-display font-bold text-sm uppercase tracking-wider active:bg-[#0B2A4F]"
          data-testid="mobile-cta-call"
        >
          <Phone size={18} />
          Appeler
        </a>
        <button
          onClick={scrollToDevis}
          className="flex items-center justify-center gap-2 bg-[#1F6FD6] text-white py-3 rounded-md font-display font-bold text-sm uppercase tracking-wider active:bg-[#3B8BEF]"
          data-testid="mobile-cta-quote"
        >
          <FileText size={18} />
          Devis gratuit
        </button>
      </div>
    </div>
  );
};

export default MobileCTA;
